import { ErrorHandler, Output, EventEmitter, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiReturn } from '@library-shared/models/api-return';
import { HttpClient } from '@angular/common/http';
import { Log, Logger } from '@nhustak/angular-lib';

@Injectable({
    providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
    public static apiURL: string;
    log: any;

    constructor(private injector: Injector) {
        this.log = Log.create(this.constructor.name);
    }

    handleError(error) {
        console.error('An error occurred:', error.message);
        this.log.error(error.message, error);
        try {
            this.Log_Error({ error_message: error.message + '\n' + error.stack }).subscribe();
        } catch {}
    }

    Log_Error(req: { error_message: string }): Observable<ApiReturn> {
        const http = this.injector.get(HttpClient);
        const url = `${GlobalErrorHandlerService.apiURL}/api/error/log`;
        return http.post<ApiReturn>(url, req, {});
        //.pipe(catchError((e) => console.error(e)));
    }
}
